// Payments — Stripe MEMBERSHIP payments + subscription states only. There is no clinical-billing
// surface here: Healthie owns clinical billing; CC holds no clinical-billing records (D5/D8).
import { Surface } from "@championcare/ui";
import { useApi } from "../api";
import { useAsync } from "../lib/useAsync";
import { cap, formatDateTime, formatMoney, shortId } from "../lib/format";
import { Loading, ErrorState, EmptyState, PageHeader, StatusBadge } from "../components/ui";

export function Payments() {
  const api = useApi();
  const { data, loading, error } = useAsync(() => api.payments(), []);
  if (loading) return <Loading />;
  if (error) return <ErrorState message={error} />;
  if (!data) return <ErrorState message="Unavailable." />;

  return (
    <div className="page">
      <PageHeader title="Payments" sub="Membership billing only." />
      <p className="muted">
        Membership subscriptions and payments only. All clinical billing lives in Healthie —
        Champion Care holds none of it.
      </p>

      <h2 className="section-title">Subscriptions</h2>
      <Surface className="card">
        {data.subscriptions.length ? (
          <table className="tbl">
            <thead>
              <tr>
                <th>Member</th>
                <th>Plan</th>
                <th>Status</th>
                <th>Renews</th>
              </tr>
            </thead>
            <tbody>
              {data.subscriptions.map((s, i) => (
                <tr key={i}>
                  <td className="mono">{shortId(s.patient_id)}</td>
                  <td>{cap(s.product)}</td>
                  <td>
                    <StatusBadge value={s.status} />
                  </td>
                  <td className="mono">{formatDateTime(s.current_period_end)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <EmptyState>No subscriptions.</EmptyState>
        )}
      </Surface>

      <h2 className="section-title">Payments</h2>
      <Surface className="card">
        {data.payments.length ? (
          <table className="tbl">
            <thead>
              <tr>
                <th>Member</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {data.payments.map((p, i) => (
                <tr key={i}>
                  <td className="mono">{shortId(p.patient_id)}</td>
                  <td>{formatMoney(p.amount_cents, p.currency)}</td>
                  <td>
                    <StatusBadge value={p.status} />
                  </td>
                  <td className="mono">{formatDateTime(p.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <EmptyState>No payments.</EmptyState>
        )}
      </Surface>
    </div>
  );
}
